import React from 'react';
import { formatCurrencyInput, formatDateInput } from '../../utils/inputValidation';

const PROVINCIAS = [
    'Buenos Aires', 'CABA', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba',
    'Corrientes', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja',
    'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan',
    'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'
];

const TIPOS_EMPRESA = [
    'Sociedad Anónima',
    'Sociedad de Responsabilidad Limitada',
];

const PersonaJuridicaForm = ({ formData, setFormData, caseType }) => {
    const isStored = caseType === 'STORED';

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'ingresosEmpresa') {
            setFormData(prev => ({ ...prev, [name]: formatCurrencyInput(value) }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleValidarEmail = () => {
        if (formData.emailEmpresa) {
            alert(`Validando email: ${formData.emailEmpresa}`);
        } else {
            alert('Por favor ingrese un email primero');
        }
    };

    const inputClass = (stored) =>
        `w-full px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm focus:outline-none transition-all duration-200 ${stored
            ? 'bg-gray-100 cursor-default'
            : 'bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500'
        }`;

    return (
        <>
            {/* DATOS DE LA EMPRESA */}
            <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">
                <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>
                <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">
                    <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">
                        <span className="material-icons text-honda-600">business</span>
                        DATOS DE LA EMPRESA
                    </h3>
                </div>
                <div className="p-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Fecha de Constitución</label>
                            <input
                                type="text"
                                name="fechaConstitucion"
                                value={formData.fechaConstitucion || ''}
                                onChange={(e) => {
                                    if (isStored) return;
                                    setFormData(prev => ({ ...prev, fechaConstitucion: formatDateInput(e.target.value) }));
                                }}
                                readOnly={isStored}
                                placeholder="dd/mm/aaaa"
                                maxLength="10"
                                className={inputClass(isStored)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Tipo de Empresa <span className="text-red-500">*</span></label>
                            <select
                                name="tipoEmpresa"
                                value={formData.tipoEmpresa || ''}
                                onChange={handleChange}
                                disabled={isStored}
                                className={inputClass(isStored)}
                            >
                                <option value="">Seleccione...</option>
                                {TIPOS_EMPRESA.map(t => (
                                    <option key={t} value={t}>{t}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Objeto de Empresa <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="objetoEmpresa"
                                value={formData.objetoEmpresa || ''}
                                onChange={handleChange}
                                readOnly={isStored}
                                placeholder="Objeto de Empresa"
                                className={inputClass(isStored)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Ingresos <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="ingresosEmpresa"
                                value={formData.ingresosEmpresa || ''}
                                onChange={handleChange}
                                readOnly={isStored}
                                placeholder="AR$ 0,00"
                                className={inputClass(isStored)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">PEP <span className="text-red-500">*</span></label>
                            <select
                                name="pepEmpresa"
                                value={formData.pepEmpresa || ''}
                                onChange={handleChange}
                                disabled={isStored}
                                className={inputClass(isStored)}
                            >
                                <option value="">Seleccione...</option>
                                <option value="SI">Sí</option>
                                <option value="NO">No</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Teléfono <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                name="telefonoEmpresa"
                                value={formData.telefonoEmpresa || ''}
                                onChange={handleChange}
                                readOnly={isStored}
                                placeholder="Teléfono"
                                className={inputClass(isStored)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-xs font-medium text-gray-500 mb-1">E-Mail <span className="text-red-500">*</span></label>
                            <div className="flex gap-2">
                                <input
                                    type="email"
                                    name="emailEmpresa"
                                    value={formData.emailEmpresa || ''}
                                    onChange={handleChange}
                                    readOnly={isStored}
                                    placeholder="email@empresa.com"
                                    className={`flex-1 min-w-0 px-3 py-2 border border-gray-200 rounded-md text-gray-800 text-sm focus:outline-none transition-all duration-200 ${isStored ? 'bg-gray-100 cursor-default' : 'bg-gray-50 focus:border-honda-500 focus:ring-1 focus:ring-honda-500'}`}
                                />
                                {!isStored && (
                                    <button
                                        onClick={handleValidarEmail}
                                        type="button"
                                        className="px-4 py-2 gradient-red hover:shadow-glow-red text-white rounded-lg transition-all duration-300 text-sm font-medium whitespace-nowrap hover:scale-105 transform"
                                    >
                                        Validar
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* DIRECCIÓN DE LA EMPRESA */}
            <div className="mb-6 bg-white border-2 border-gray-100 rounded-2xl shadow-soft hover:shadow-xl transition-all duration-300 overflow-hidden group">
                <div className="h-1.5 gradient-red group-hover:h-2 transition-all duration-300"></div>
                <div className="bg-gradient-to-br from-honda-50 to-white px-6 py-4 border-b border-gray-100">
                    <h3 className="text-sm font-bold text-honda-800 uppercase tracking-wide flex items-center gap-2">
                        <span className="material-icons text-honda-600">location_on</span>
                        DIRECCIÓN DE LA EMPRESA
                    </h3>
                </div>
                <div className="p-4">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Dirección <span className="text-red-500">*</span></label>
                            <input type="text" name="direccion" value={formData.direccion || ''} onChange={handleChange} readOnly={isStored} placeholder="Calle" className={inputClass(isStored)} />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Número <span className="text-red-500">*</span></label>
                            <input type="text" name="numero" value={formData.numero || ''} onChange={handleChange} readOnly={isStored} placeholder="Número" className={inputClass(isStored)} />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Piso / Dpto</label>
                            <input type="text" name="pisoDpto" value={formData.pisoDpto || ''} onChange={handleChange} readOnly={isStored} placeholder="Piso / Dpto" className={inputClass(isStored)} />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Código Postal <span className="text-red-500">*</span></label>
                            <input type="text" name="codigoPostal" value={formData.codigoPostal || ''} onChange={handleChange} readOnly={isStored} placeholder="Código Postal" className={inputClass(isStored)} />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Localidad <span className="text-red-500">*</span></label>
                            <input type="text" name="localidad" value={formData.localidad || ''} onChange={handleChange} readOnly={isStored} placeholder="Ciudad/Localidad" className={inputClass(isStored)} />
                        </div>
                        <div>
                            <label className="block text-xs font-medium text-gray-500 mb-1">Provincia <span className="text-red-500">*</span></label>
                            <select name="provincia" value={formData.provincia || ''} onChange={handleChange} disabled={isStored} className={inputClass(isStored)}>
                                <option value="">Seleccione...</option>
                                {PROVINCIAS.map(p => <option key={p} value={p}>{p}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PersonaJuridicaForm;
